import React from 'react';
import { Link } from 'react-router-dom';
import { Trophy, Music, Building, Users, GraduationCap, Layers, ArrowRight, CheckCircle } from 'lucide-react';
import Layout from '../components/layout/Layout';
import '../styles/pages.css';
import usePageMeta from '../hooks/usePageMeta';

const eventTypesData = [
  {
    id: 1,
    name: "Eventos Deportivos",
    icon: Trophy,
    description: "Partidos, torneos, competencias y eventos deportivos de cualquier escala.",
    considerations: [
      "Gestión de aficionados y barras",
      "Control de accesos diferenciados",
      "Coordinación con ligas y federaciones",
      "Protocolos anti-violencia"
    ]
  },
  {
    id: 2,
    name: "Conciertos y Espectáculos",
    icon: Music,
    description: "Conciertos, festivales, obras de teatro y espectáculos en vivo.",
    considerations: [
      "Gestión de multitudes",
      "Zonas VIP y backstage",
      "Control de mercancía y pirataje",
      "Evacuación de grandes aforos"
    ]
  },
  {
    id: 3,
    name: "Eventos Corporativos",
    icon: Building,
    description: "Juntas de consejo, lanzamientos de producto, eventos empresariales.",
    considerations: [
      "Confidencialidad de información",
      "Protección de ejecutivos",
      "Control de medios",
      "Gestión de invitados selectos"
    ]
  },
  {
    id: 4,
    name: "Convenciones",
    icon: Users,
    description: "Convenciones, exposiciones, ferias comerciales y eventos de networking.",
    considerations: [
      "Control de expositores",
      "Gestión de credenciales",
      "Protección de stands y productos",
      "Flujos de visitantes"
    ]
  },
  {
    id: 5,
    name: "Eventos Académicos",
    icon: GraduationCap,
    description: "Congresos, simposios, graduaciones y eventos universitarios.",
    considerations: [
      "Protección de ponentes",
      "Control de asistencia",
      "Gestión de materiales sensibles",
      "Coordinación con instituciones"
    ]
  },
  {
    id: 6,
    name: "Eventos Masivos",
    icon: Layers,
    description: "Eventos públicos de gran escala con alto volumen de asistentes.",
    considerations: [
      "Planes de contingencia robustos",
      "Múltiples puntos de control",
      "Coordinación interinstitucional",
      "Sistemas de comunicación redundantes"
    ]
  }
];

const EventTypes = () => {
  usePageMeta({
    title: 'Tipos de Eventos',
    description: 'Experiencia en eventos deportivos, conciertos, corporativos, convenciones, académicos y masivos de alta complejidad.',
    path: '/event-types',
  });

  return (
    <Layout>
      {/* Page Header */}
      <section className="page-header">
        <div className="container">
          <h1>Tipos de Eventos</h1>
          <p>Experiencia en eventos de diversa naturaleza y complejidad</p>
        </div>
      </section>

      {/* Introduction */}
      <section className="section">
        <div className="container">
          <div className="intro-content">
            <p className="lead-text">
              Cada tipo de evento presenta desafíos únicos de seguridad. Nuestra experiencia 
              abarca una amplia variedad de eventos, lo que nos permite adaptar nuestras 
              metodologías a las características específicas de cada situación.
            </p>
          </div>
        </div>
      </section>

      {/* Event Types */}
      <section className="section section-alt">
        <div className="container">
          <div className="event-types-list">
            {eventTypesData.map((event) => {
              const IconComponent = event.icon;
              return (
                <div key={event.id} className="event-type-card">
                  <div className="event-type-header">
                    <div className="event-type-icon">
                      <IconComponent size={32} />
                    </div>
                    <div>
                      <h3>{event.name}</h3>
                      <p>{event.description}</p>
                    </div>
                  </div>
                  <div className="event-type-considerations">
                    <span className="considerations-label">Consideraciones clave:</span>
                    <ul>
                      {event.considerations.map((item, index) => (
                        <li key={index}>
                          <CheckCircle size={14} />
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>¿Tiene un evento diferente?</h2>
            <p>
              No importa el tipo de evento, podemos adaptar nuestra metodología 
              a sus necesidades específicas.
            </p>
            <Link to="/contact" className="btn btn-primary">
              Contáctenos
              <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default EventTypes;
